<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M11.0303 1.02124C16.5035 1.02124 20.9404 5.45817 20.9404 10.9314C20.9404 16.4046 16.5035 20.8416 11.0303 20.8416C5.55704 20.8415 1.12012 16.4046 1.12012 10.9314C1.12012 5.45817 5.55705 1.02125 11.0303 1.02124Z"
      fill="#FFC682"
      stroke="#FFC682"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2LogosFinanceNav'
})
</script>
